import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  LOGIN_INFO_REDUCER_NAME,
  UserInfoStateStructure
} from '@ptl/account-management';
import { BrandingConfigurationService } from '@ptl/brand';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { Prospect } from '../../../interfaces/prospect.interface';
import { FFMRedirectService } from '../../../services/ffmredirect.service';

@Component({
    selector: 'app-go-to-marketplace-modal',
    templateUrl: './go-to-marketplace-modal.component.html',
    styleUrls: ['./go-to-marketplace-modal.component.scss'],
    standalone: false
})
export class GoToMarketplaceModalComponent implements OnInit {

  provider: string;

  constructor(
    private brandService: BrandingConfigurationService,
    private dialogRef: MatDialogRef<GoToMarketplaceModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      countyExcludedFromONX: boolean;
      prospects: Prospect[];
      selectedProspect: Prospect;
    },
    private ffmRedirectService: FFMRedirectService,
    private reducerUtilityService: ReducerUtilityService
  ) {}

  ngOnInit(): void {
    this.provider = this.brandService.getCurrentBrand().description;
  }

  closeModal() {
    this.dialogRef.close();
  }

  async goToMarketplace() {
    await this.ffmRedirectService.goToMarketplace(
      this.data.selectedProspect,
      this.data.prospects
    );
    this.dialogRef.close();

  }
}
